<script>
  import './style.scss';
  import '@braid/vue-formulate/themes/snow/snow.scss';
  import "filepond/dist/filepond.min.css";
  import {isEmpty, isArray} from 'lodash';
  import Vue from 'vue'
  import { FileStatus, FileOrigin } from 'filepond';
  import {EventBus} from "../../event-bus";
  import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
  import { getterSetterDeliveryOptionValue } from './getter-setter-delivery-option';
  import { getterSetterOrderDetailsValue } from './getter-setter-order-details';
  import { createPopper } from '@popperjs/core'
  import template from './template.html';
  import OrderDetails from './Order-Details/OrderDetails.vue';
  import UploadFiles from './Upload-Files/UploadFiles.vue';
  import DeliveryOptions from './Delivery-Options/DeliveryOptions.vue';
  import SelectLanguages from './Select-Languages/SelectLanguages.vue';
  import OnBehalf from './On-Behalf/OnBehalf.vue';
  import axios from 'axios';
  import moment from 'moment';
  import Notifications from 'vue-notification';
  import CoStep from './Co-Step/CoStep.vue';

  Vue.use(Notifications);

  const filePondDeleteMethod = (source, load, error) => {

    // Should send `source` to server so server can remove the file with this source
    axios({
      method: 'DELETE',
      url: `/file/${source}`
    }).then(result => {
      // Should call the load method when done, no parameters required
      load();
    }).catch(err => {
      // Can call the error method if something is wrong, should exit after
      error('oh no!');
    })
  };

  function onUnLoad () {
    return "Would you like to save this order to complete later?";
  }

  export default {
    template,
    components: {
      OnBehalf,
      UploadFiles,
      OrderDetails,
      SelectLanguages,
      DeliveryOptions,
      CoStep,
    },
    props: {
      userId: [Number, String],

      deliveryOptions: Object,

      options: Object,

      orderId: {
        type: [String, Number],
        default: 0
      },

      programsEnabled: {
        type: Boolean,
        default: false
      },

      isProgramMandatory: {
        type: Boolean,
        default: false
      },

      editMode: {

        type: Boolean,

        default: false
      },

      environment: {
        type: String
      },

      onBehalfData: {
        type: [Object, Array],
        default: () => {},
      }
    },
    data () {

      return {
        fileIsUploading: false,

        hasSeenNotifyWarning: false,

        unloadEventSet: false,

        isSubmitted: false,

        account: window.backend.account,

        context: {},

        order: {},

        formValues: {},

        selectLanguageOptionsUrl: "/create-order/select-languages/options",

        deliveryOptionsUrl: "/create-order/delivery-options/options",

        statusTimestamp: '',

        message: '',

        orderDetailsOptions: {
          tags: [],
          types: [],
          order_numbers: [],
          programs: [],
          po_required: 0,
          order_type_required: 0,
          tag_settings: {},
          tag_required: false,
          default_order_type: {},
        },
      }
    },

    beforeMount () {
      //get the options for order details dropdowns
      //@TODO - move this to order details component
      this.message = '';

      this.getOrderDetailsOptions().then((options) => {

        let { tags, types, order_numbers, programs, po_required, order_type_required, tag_settings, default_order_type } = options;

        //remove bracket information from order types
        types = types.map(type => {
          return Object.assign({}, type, {name: type.name.replace(/ *\[[^\]]*]/, '').trim()});
        });

        //set a default order type if ther eis one
        if (default_order_type.enabled) {
          this.type = parseInt(default_order_type.plunetId);
        }

        this.orderDetailsOptions = Object.assign({}, this.orderDetailsOptions, {
          tags,
          types,
          order_numbers: order_numbers || [],
          po_required: parseInt(po_required),
          order_type_required: parseInt(order_type_required),
          programs,
          tag_settings,
          tag_required: tag_settings.tag_required,
          default_order_type
        });
      });

      //if this is a previously created or 'new' order
      if (this.isNewOrder) {
        //the order has been previously saved by the user
        const isSavedOrder = (order) => {
          return !isEmpty(order.details.name);
        };

        this.getOrder(this.orderId).then(order => {
          this.order = order;

          this.initOrder(order, isSavedOrder(order));

          if (
            !this.isSavedOrder
            && this.environment !== 'testing'
            && this.environment !== 'ci'
          ) {
            $(window).one('beforeunload', onUnLoad);
            this.unloadEventSet = true;
          }
        })
      }
    },

    created () {
      //set behalf user and account
      this.setBehalfAccount(this.account.id);
      this.setBehalfUser(auth.id);
    },

    computed: {

      ...mapState({
        coStore: state => state.CreateOrderStore,
        source_language: state => state.CreateOrderStore.selectLanguages.source_language,
        connector_delivery_method: state => state.CreateOrderStore.deliveryOptions.connector_delivery_method,
        quote: state => state.CreateOrderStore.orderDetails.quote,
        uploadFileType: state => state.CreateOrderStore.orderDetails.uploadFileType,
        activeConnectors: state => state.ConnectorTilesStore.activeConnectors
      }),

      ...mapGetters('CreateOrderStore', [
        'onBehalf',
        'sourceLanguages',
      ]),

      ...mapGetters('ConnectorTilesStore', [
        'nameOfActiveConnectors',
      ]),

      ...mapGetters('AuthStore', [
        'isAdminUser',
      ]),

      /**
       * Getter/setter for order name
       *
       */
      name: {
        //get the order name
        get () {
          return this.coStore.orderDetails.name;
        },

        //set the order name
        set (value) {
          this.updateOrderName(value);
        }
      },

      //order details params
      due_at: getterSetterOrderDetailsValue('due_at'),
      purchase_order_number: getterSetterOrderDetailsValue('purchase_order_number'),
      type: getterSetterOrderDetailsValue('type'),
      tags: getterSetterOrderDetailsValue('tags'),
      quote: getterSetterOrderDetailsValue('quote'),
      program: getterSetterOrderDetailsValue('program'),
      auto_approve: getterSetterOrderDetailsValue('auto_approve'),
      auto_approve_amount: getterSetterOrderDetailsValue('auto_approve_amount'),

      //delivery options params
      notify_on_order_submit: getterSetterDeliveryOptionValue('notify_on_order_submit'),
      notify_on_new_comment: getterSetterDeliveryOptionValue('notify_on_new_comment'),
      notify_on_order_complete: getterSetterDeliveryOptionValue('notify_on_order_complete'),
      emails_to_notify: getterSetterDeliveryOptionValue('emails_to_notify'),
      connector_delivery_method: getterSetterDeliveryOptionValue('connector_delivery_method'),
      comment: getterSetterDeliveryOptionValue('comment'),

      /**
       * getter/setter for target languages
       *
       */
      target_languages: {
        get () {
          return this.coStore.selectLanguages.target_languages;
        },

        set (value) {
          this.updateTargetLanguages(value)
        }
      },

      //checks if we are updating an existing(new) order
      isNewOrder () {
        return !isEmpty(this.orderId);
      },

      /**
       * get order status
       *
       * @return boolean
       */
      isSavedOrder () {
        if (!this.order?.details) return false;

        return this.order?.details.name.length > 1;
      }
    },
    methods: {
      // TODO break down into a utility file/smaller components
      ...mapActions('CreateOrderStore', [
        'updateOrderDetailsValue',
        'updateSourceLanguage',
        'updateDeliveryOption',
        'updateConnectorDeliveryMethod',
        'updateTargetLanguages',
        'updateOrderName',
        'updateFiles',
        'onNotifyEmail',
        'getSourceLanguages',
        'getUserLanguageSets',
        'getAccountLanguageSets',
        'getTargetLanguages'
      ]),

      ...mapMutations('CreateOrderStore', [
        'setOrderDetailsValue',
        'setSourceLanguage',
        'setDeliveryOption',
        'setConnectorDeliveryMethod',
        'setTargetLanguages',
        'setOrderName',
        'setFiles',
        'setBehalfAccount',
        'setBehalfUser',
        'setUploadFileType'
      ]),

      /**
       * When a user selects a program
       *
       * @param Object file
       */
      onProgramSelected () {
        //remove unsaved order alert
        this.removeUnsavedOrderAlert();
      },

      
      /**
       * Empty details for on-behalf company
       *
       */
      async setBehalfAccount() {
        try {

          // Update the component data properties
          this.orderDetailsOptions = Object.assign({}, this.orderDetailsOptions, {
            tags: [],
            types: [],
            order_numbers: [],
            po_required: [],
            programs: [],
            tag_settings: [],
            tag_required: '',
            default_order_type: [],
          });
          this.message = 'Please select a user to update Order details.';
        } catch (error) {
          console.error('Error fetching order details:', error);
        }
      },

      /**
       * When a user sets an on-behalf account
       *
       */
      async onBehalfSet(userId) {
        try {
          let result = await this.getOrderDetailsOptions(userId);

          let { tags, types, order_numbers, programs, po_required, tag_settings, default_order_type } = result;

          // Modify the retrieved data
          types = types.map(type => {
            return Object.assign({}, type, {name: type.name.replace(/ *\[[^\]]*]/, '').trim()});
          });

          if (result.default_order_type.enabled) {
            this.type = parseInt(result.default_order_type.plunetId);
          }

          // Update the component data properties
          this.orderDetailsOptions = Object.assign({}, this.orderDetailsOptions, {
            tags,
            types,
            order_numbers: order_numbers || [],
            po_required: parseInt(po_required),
            programs,
            tag_settings,
            tag_required: tag_settings.tag_required,
            default_order_type
          });
          this.selectLanguageOptionsUrl = `/create-order/select-languages/options/${userId}`;
          this.deliveryOptionsUrl = `/create-order/delivery-options/options/${userId}`;
          this.order = { ...this.order };
          this.message = '';
          this.$parent.userId = userId;
        } catch (error) {
          console.error('Error fetching order details:', error);
        }

      },


      //@TODO - remove jquery dep
      csrfToken () {

        // ge
        return $("[name='_token']").val();
      },

      /**
       * A new file is being uploaded
       *
       * @param Object file
       */
      onFileUploading (file) {
        this.fileIsUploading = true;
      },

      /**
       * All files have finished uploading
       *
       * @param Object file
       */
      onFileUploadComplete (files) {
        this.fileIsUploading = false;
      },

      /**
       * Load previous order files into filepond
       *
       *
       */
      getUploadedFiles () {
        return axios
          .get(`/create-order/uploaded-files/${this.orderId || 0}`)
          .then(result => result.data.files);
      },

      /**
       * Build a formatted timestamp for the saved order
       *
       * @param String date - a dateTime string
       */
      _buildStatusTimestamp (date) {
        //constuct order timestamp
        let a = moment(date);
        let b = moment();

        let minutes = b.diff(a, 'minutes') ? ` ${b.diff(a, 'minutes')} minutes` : '';
        let days = b.diff(a, 'days') ? ` ${b.diff(a, 'days')} days` : '';
        let seconds = b.diff(a, 'seconds') ? ` ${b.diff(a, 'seconds')} seconds` : '';
        let hours = b.diff(a, 'hours') ? ` ${b.diff(a, 'hours')} hours` : '';

        let status = days || hours || minutes || seconds;

        if (status.indexOf(' 1 ') > -1) {
          status = status.replace(/s$/,"");
        }

        return `${status} ago`;
      },

      /**
       * Setup data for previously saved order
       *
       * @param Object order
       */
      initOrder (order, setSavedOrderData) {
        let { name, order_type, po_number, quote_required, delivery_method, due_at, auto_approve, auto_approve_amount, program_id } = order.details;
        let { notify_on_new_comment, notify_on_order_complete, notify_on_order_submit } = order.deliveryOptions;

        let comments = order.comments[0];

        if (comments) {
          comments = comments.body_html;
        }

        if (due_at) {
          due_at = moment(due_at).format('YYYY-MM-DD');
        }

        //add program if there is one
        if (program_id) {
          this.program = program_id.toString();
        }

        //constuct order timestamp
        this.statusTimestamp = this._buildStatusTimestamp(order.details.modified_at);

        //we do not want to fill the order form with the previously
        //saved order data
        //this is probably because this order was created by the system and not the user
        if (!setSavedOrderData) return;

        //set order name
        this.name = name;

        //set due at
        this.due_at = due_at;

        //set order details type
        this.type = order_type;

        //set purchase order number
        this.purchase_order_number = po_number;

        //set auto approve
        this.auto_approve = auto_approve ? true : false;
        this.auto_approve_amount = auto_approve_amount || 500;

        //set tags
        this.tags = order.selected_tags;
        this.quote = quote_required;

        //set delivery options
        this.notify_on_new_comment = notify_on_new_comment;
        this.notify_on_order_complete = notify_on_order_complete;
        this.notify_on_order_submit = notify_on_order_submit;

        //set delivery connector method
        this.connector_delivery_method = delivery_method

        //set email recepients

        let recipeints = order.selected_email_recipients;

        if (!isArray(order.selected_email_recipients)) {
          recipeints = order.selected_email_recipients.split(',');
        }

        this.emails_to_notify = recipeints;

        this.comment = comments;
      },

      /**
      * Get dropdown/select options values for
      * Order details
      *
      */
      getOrderDetailsOptions(userId) {
        const url = '/create-order/order-details/options' + (userId ? `/${userId}` : '');

        return axios
          .get(url)
          .then((result) => result.data);
      },

      /**
       * Get Order (for editing orders)
       *
       * @param Number orderId
       * @return Object Order
       */
      getOrder (orderId) {
        return axios
          .get(`/create-order/new-order/${orderId}`)
          .then(result => result.data.data)
      },

      /**
       * confirmation modal for deleting a saved order
       *
       */
      confirmDeleteOrder () {
        this.$modal.show({
          name: 'delete_order_modal',

          template: `
            <section class="create-order-modal">
              <header class="co-modal-header">
                <h1>Delete Order</h1>
              </header>
              <div class="co-modal-content">
                <p>Are you sure you want to delete this order?</p>
              </div>
              <div class="co-modal-footer two-btns">
                <button @click="remove()" class="popup-confirm-btn btn-primary">Delete</button>
                <button @click="cancel()" class="popup-cancel-btn btn-secondary co-cancel-btn"">Cancel</button>
              </div>
            </section>`

          ,props: ['remove', 'cancel']
        },{
          remove: () => {
            axios({
              method: 'POST',
              url: `/orders/${this.orderId}`,
              data: {
                _method: 'DELETE',
                _token: this.csrfToken()
              }
            }).then(() => {
              window.location.href = '/orders/view';
            })
          },
          cancel: () => this.$modal.hide('delete_order_modal')
        },{
          width: 450,
          height: 150,
          name: 'delete_order_modal'
        });
      },

      /**
       * Show form errors
       *
       * @param Array errors
       */
      formErrorsModal (errors = []) {
        let errorsHtml = '';

        errors.forEach(err => errorsHtml += `<li>${err}</li>`);

        this.$modal.show('dialog', {
          title: `<span class="co-dialog-error">Required Information Missing:</span>`,
          text: `
            <ul>
              ${errorsHtml}
            </ul>
          `,
          buttons: [
            {
              title: 'OK',
              class: 'vue-dialog-button reviewer-dialog-btn close-btn',
              handler: () => {
                this.$modal.hide('dialog')
              }
            }
          ]
        });
      },

      /**
       * Get order object for submissions and updates
       *
       */
      getOrderObject () {
        let {
          name,
          due_at,
          type,
          purchase_order_number,
          auto_approve,
          auto_approve_amount,
          quote,
          tags
        } = this.coStore.orderDetails;

        let {
          source_language,
          source_language_description,
          target_languages
        } = this.coStore.selectLanguages;

        let {
          notify_on_order_submit,
          notify_on_new_comment,
          notify_on_quote_ready,
          notify_on_order_complete,
          emails_to_notify,
          connector_delivery_method,
          comment
        } = this.coStore.deliveryOptions;

        let { files } = this.coStore.uploadFiles;

        let {
          behalf_account,
          behalf_user
        } = this.coStore.onBehalf;

        //format due date
        if (due_at) {
          due_at = moment(due_at).format('D-MMM-YYYY');
        }

        //set tags to an array if it's not
        if (!isArray(tags) && tags) {
          tags = [tags];
        }

        return {
          _token: this.csrfToken(),
          name,
          due_at,
          type,
          purchase_order_number,
          tags, //@TODO tags should be multiselect
          auto_approve_amount: parseInt(auto_approve_amount) || 500,
          auto_approve,
          quote: parseInt(quote),

          //@TODO - is this needed?
          files: files || [],
          source_language,
          "source-language": source_language_description, // rename to source_language
          target_languages: target_languages.map(lang => lang.id),
          notify_on_order_submit,
          notify_on_new_comment,
          notify_on_quote_ready,
          notify_on_order_complete,
          emails_to_notify: isArray(emails_to_notify) ? emails_to_notify : emails_to_notify.split(','),
          connector_delivery_method,
          comment: comment || "",
          behalf_account, //window.backend.account.id,
          behalf_user: parseInt(behalf_user),
          status: 'submit_order'
        }
      },

      /**
       * get any visible form errors
       *
       * @return array errors
       */
      getFormErrors () {
        let errors = [];
        let formErrors = this.$refs.formulateForm.failingFields;
        let formErrorKeys = Object.keys(formErrors);

        //console.log('the form errors', formErrors)

        //check for vue formulate errors
        if (formErrorKeys.length) {
          formErrorKeys.forEach(err => {
            let error = formErrors[err];

            errors = errors.concat(error.validationErrors);
          })
        }

        //check for target language errors
        //@TODO - move this to vue formulate so we don't have to
        //check individually
        if (this.target_languages.length < 1) {
          errors.push('Select at least one target language.');
        }

        if(this.isProgramMandatory && !this.program) {
          errors.push('Please select a program.');
        }

        if(this.isProgramMandatory && !this.program) {
          errors.push('Please select a program');
        }

        //check if tag is required
        if (this.orderDetailsOptions.tag_required && this.tags.length < 1) {
          errors.push('Please add at least one tag.');
        }

        //check if purchase order number is required
        if (this.orderDetailsOptions.po_required && !this.purchase_order_number) {
          errors.push('Your organization requires a Purchase Order number.');
        }

        //check if order type is required
        if (this.orderDetailsOptions.order_type_required && !this.type) {
          errors.push('Your organization requires an Order Type.');
        }

        //if the user hasn't added any emails to notify
        if (!this.emails_to_notify.length && !this.hasSeenNotifyWarning) {
          errors.push("<b>Warning</b>: To receive email notifications about your order add one or more email addresses.");
          this.hasSeenNotifyWarning = true;
        }

        return errors
      },

      /**
       * Save Order for editing later
       *
       */
      saveOrder () {
        let order = this.getOrderObject()
        let errors = this.getFormErrors();

        //check for form errors
        if (errors.length) {
          return this.formErrorsModal(errors);
        }

        if (this.unloadEventSet) {
          this.removeUnsavedOrderAlert();
        }

        order = Object.assign({}, order, {
          status: 'save_order'
        });

        EventBus.$emit('loader:show');

        return axios({
          method: 'post',
          url: '/orders',
          data: order
        }).then(result => {
          window.location = `/create-order/show/${result.data.orderId}`;
        }).finally(() => {
          EventBus.$emit('loader:hide');
        })
      },

      /**
       * Update Order
       */
      updateOrder () {
        let order = this.getOrderObject();
        let errors = this.getFormErrors();

        //check for form errors
        if (errors.length) {
          return this.formErrorsModal(errors);
        }

        if (this.unloadEventSet) {
          this.removeUnsavedOrderAlert();
        }

        order = Object.assign({}, order, {
          _method: 'PUT',
          status: 'save_order',
          order_id: this.orderId,
          target_languages: order.target_languages.toString()
        });

        EventBus.$emit('loader:show');

        return axios({
          method: 'POST',
          url: `/orders/update?orderid=${this.orderId}`,
          data: order
        }).then(result => {
          this.$notify({
            group: 'foo',
            type: 'success',
            title: 'Your order has been saved',
            text: `Order #${this.orderId} saved successfully!`,
            duration: 5000,
            speed: 1000,
            animation: {
              enter: { height: 200, opacity: 1 },
              leave: { height: 0, opacity: 0}
            },
            data: {}
          })
        }).finally(() => {
          EventBus.$emit('loader:hide');
        })
      },

      /**
       * Submit order
       *
       */
      submitOrder () {
        if (this.isSubmitted) {
          return;
        }

        this.isSubmitted = true;

        let order = this.getOrderObject();
        let errors = this.getFormErrors();
        let order_id = undefined;
        let _method = 'POST';
        let url = '/orders';
        let target_languages = order.target_languages;

        //check for form errors
        if (errors.length) {
          this.isSubmitted = false;
          return this.formErrorsModal(errors);
        }

        if (this.unloadEventSet) {
          this.removeUnsavedOrderAlert();
        }

        //used when we're submitting a previously saved order
        if (this.orderId && this.editMode) {
          order_id = this.orderId;
          _method = 'PUT';
          url = `/orders/update?orderid=${this.orderId}`;
          target_languages = order.target_languages.toString();
        }

        order = Object.assign({}, order, {
          _method,
          order_id,
          target_languages
        });

        EventBus.$emit('loader:show');

        return axios({
          method: 'post',
          url,
          data: order
        }).then(result => {
          let orderId = this.orderId && this.editMode ? this.orderId : result.data.orderId;

          window.location = `/orders/confirmation/${orderId}`;
        }).finally(() => {
          this.isSubmitted = false;
          EventBus.$emit('loader:hide');
        })
      },

      /**
       * Remove unsaved order alert
       *
       */
      removeUnsavedOrderAlert () {
        $(window).off('beforeunload', onUnLoad);
        this.unloadEventSet = false;
      }
    },
  }
</script>
